/**
 * モックモード判定ユーティリティ
 * 
 * モックモードはURLクエリパラメータで有効化できます：
 * - `?mock=true` でモックモード有効化
 * - `?mock=false` でモックモード無効化
 * 
 * クエリパラメータでモックモードを有効化した場合、
 * sessionStorageに保存され、ページ内遷移でも維持されます。
 */

const MOCK_STORAGE_KEY = 'mockModeEnabled';

/**
 * モックモードが有効かどうかを判定
 * - クエリパラメータまたはsessionStorageで有効化されていればtrue
 */
export function isMockEnabled(): boolean {
  // 1. クエリパラメータ（?mock=true）
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('mock') === 'true') {
    // sessionStorageに保存してページ遷移後も維持
    sessionStorage.setItem(MOCK_STORAGE_KEY, 'true');
    return true;
  }

  // モックを無効化するパラメータ（?mock=false）
  if (urlParams.get('mock') === 'false') {
    sessionStorage.removeItem(MOCK_STORAGE_KEY);
    return false;
  }

  // 3. sessionStorageに保存された値
  if (sessionStorage.getItem(MOCK_STORAGE_KEY) === 'true') {
    return true;
  }

  return false;
}

/**
 * モックモードを手動で無効化
 */
export function disableMockMode(): void {
  sessionStorage.removeItem(MOCK_STORAGE_KEY);
  // クエリパラメータから mock を削除してリロード
  const url = new URL(window.location.href);
  url.searchParams.delete('mock');
  window.location.href = url.toString();
}
